import { useMemo, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@components/Button';
import { ModalBase } from '@components/Modal';
import { FiltersFormCreator } from '@components/FiltersFormCreator';
import { FiltersIcon } from 'assets/images/icons';
import { useTranslation, useLocations } from '@hooks';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        width: 564,
        '@media (max-width: 1024px)': {
            width: '100%',
            height: '100%',
            borderRadius: 0,
            maxHeight: 'none',
        },
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const FiltersWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: '8px',
    '@media print': {
        '& button': {
            display: 'none',
        },
    },
});

const FiltersPanel = ({ className, onApplyFilters, disabled = false, filter, setFilter }) => {
    const [refetchFilters, setRefetchFilters] = useState(false);
    const [filterNumber, setFilterNumber] = useState(0);
    const [filterOpened, setFiltersOpened] = useState(false);

    const { t } = useTranslation();
    const { getLocationsOptions } = useLocations();

    useEffect(() => {
        if (refetchFilters) {
            setRefetchFilters(false);
            onApplyFilters();
        }
    }, [refetchFilters]);

    const options = useMemo(() => {
        //locationsOptions
        const locationsOptions = getLocationsOptions();
        return {
            locations: locationsOptions,
        };
    }, []);

    const update = {
        locations: items => {
            const selectedValues = items.length ? items : [];
            setFilter(prev => ({ ...prev, locations: selectedValues }));
        },
    };

    const formOptions = [
        {
            type: 'autocomplete',
            label: t(`filters.companies`),
            value: filter.locations,
            onChange: update.locations,
            options: options.locations,
            error: !filter.locations.length,
        },
    ];

    const isValid = Object.keys(filter).every(key => {
        if (Array.isArray(filter[key])) {
            return !!filter[key].length;
        } else {
            return true;
        }
    });

    return (
        <FiltersWrapper>
            <Button
                className={className}
                variant="outlined"
                onClick={() => setFiltersOpened(true)}
                startIcon={<FiltersIcon />}
                disabled={disabled}
                sx={{ marginRight: '8px' }}
            >
                {t('buttons.filters')}
                {filterNumber > 0 ? ` (${filterNumber})` : ''}
            </Button>
            <Modal
                isOpen={filterOpened}
                handleClose={() => setFiltersOpened(false)}
                title={t('buttons.filters')}
                onPrimaryAction={() => {
                    setFilterNumber(Number(options.locations.length !== filter.locations.length));
                    setRefetchFilters(true);
                    setFiltersOpened(false);
                }}
                primaryActionDisabled={!isValid}
                primaryActionText={t('buttons.applyFilters')}
                onSecondaryAction={() => setFiltersOpened(false)}
                secondaryActionText={t('buttons.cancel')}
            >
                <FiltersFormCreator type="knowledge-base" options={formOptions} />
            </Modal>
        </FiltersWrapper>
    );
};

export default FiltersPanel;
